import { domToPng } from 'modern-screenshot';


const exportElementAsImage = async ( el, trigger, imageFileName = 'chart.png', headerRef, subHeaderRef ) => {

    trigger.style.display = 'none';

    if ( headerRef ) headerRef.style.display = 'block';

    if ( subHeaderRef ) subHeaderRef.style.display = 'block';

    domToPng( el ).then( function ( dataUrl ) {

        // download( dataUrl, imageFileName );
        const link = document.createElement( 'a' );

        link.download = imageFileName;
        link.href = dataUrl;
        link.click();

        trigger.style.display = 'flex';

        if ( headerRef ) headerRef.style.display = 'none';

        if ( subHeaderRef ) subHeaderRef.style.display = 'none';

    } );

};

export default exportElementAsImage;